"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("../slicedToArray-a539bf82.js"),
  t = require("react"),
  n = require("prop-types"),
  a = require("styled-components"),
  r = require("../grid-965d799c.js"),
  i = require("../assistiveText-80858a8d.js"),
  o = require("../sectionContainer-2a921e1c.js"),
  l = require("../typography-fb2881fe.js"),
  u = require("../taggedTemplateLiteral-97b463ad.js"),
  d = require("polished/lib/helpers/rem"),
  s = require("../picture-b1ad7caa.js");
function c(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
require("../_commonjsHelpers-f10b257f.js"), require("../extends-fa579b0f.js"), require("../objectWithoutProperties-2581b642.js"), require("classnames"), require("../styles-df7980c2.js"), require("../gradients-74ddcb08.js"), require("polished/lib/color/shade"), require("../colors-c0f39aa2.js"), require("../defineProperty-b53f90b9.js"), require("../toPropertyKey-ec4a2a72.js"), require("../breakpoints-359d04f5.js"), require("polished/lib/helpers/em");
var m,
  f,
  g,
  p,
  h,
  b,
  T,
  y,
  C,
  v,
  x,
  j,
  q = c(t),
  E = c(n),
  S = c(a),
  D = c(d),
  L = S["default"](r.Col)(m || (m = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t,
      n = e.theme,
      r = e.reverseContent,
      i = e.isTwoColumn,
      o = n.xlargeUp(),
      l = n.mediumUp();
    return o ? t = D["default"](30) : l && (t = D["default"](16)), a.css(f || (f = u._taggedTemplateLiteral(["\n      ", ";\n      ", ";\n      ", ";\n    "])), l && i && !r && "padding-right: ".concat(t), l && i && r && "padding-left: ".concat(t), (!l || !i) && "\n        display: flex;\n        align-items: center;\n        flex-direction: column\n      ");
  }),
  _ = S["default"](r.Col)(g || (g = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t,
      n = e.theme,
      r = e.reverseContent,
      i = n.xlargeUp(),
      o = n.mediumUp();
    return i ? t = D["default"](30) : o && (t = D["default"](16)), a.css(p || (p = u._taggedTemplateLiteral(["\n      ", ";\n      ", ";\n      ", "\n    "])), o && !r && "padding-left: ".concat(t), o && r && "padding-right: ".concat(t), !o && "display: none;");
  }),
  A = S["default"](r.Col)(h || (h = u._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]))),
  w = S["default"](s.PictureComponent)(b || (b = u._taggedTemplateLiteral(["\n  height: auto;\n  width: 100%;\n  background-repeat: no-repeat;\n  @media print {\n    && {\n      display: none !important;\n    }\n  }\n"]))),
  B = S["default"](r.Row)(T || (T = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.reverseContent,
      r = t.mediumUp();
    return a.css(y || (y = u._taggedTemplateLiteral(["\n      ", "\n    "])), n && r && "flex-direction: row-reverse;");
  }),
  I = S["default"].span(C || (C = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme.mediumUp();
    return a.css(v || (v = u._taggedTemplateLiteral(["\n      ", ";\n      padding-bottom: ", ";\n    "])), t && "display: none;", D["default"](32));
  }),
  P = S["default"](l.TypographyComponent)(x || (x = u._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme.mediumUp(),
      n = t ? D["default"](16) : D["default"](24);
    return a.css(j || (j = u._taggedTemplateLiteral(["\n      text-align: ", ";\n      padding-bottom: ", ";\n    "])), t ? "left" : "center", n);
  }),
  k = function k(e, t, n) {
    return q["default"].createElement(w, {
      lazyLoad: !1,
      variant: "rectangular",
      src: e,
      desktopWebpSrc: t,
      altText: n,
      fullWidth: !0
    });
  },
  O = function O(e, t) {
    var n = "h2";
    return e && t && (n = "h3"), n;
  },
  F = function F(e, t) {
    var n = "h3";
    return e && t && (n = "h4"), e || t || (n = "h2"), n;
  },
  M = function M(e, t) {
    var n = "h3";
    return e || (n = "h2"), e && !t && (n = "p"), n;
  },
  U = function U(n) {
    var u = n.backgroundVariant,
      d = n.className,
      s = n.columnContentA,
      c = n.columnContentB,
      m = n.disableBottomPadding,
      f = n.headingAssistiveText,
      g = n.headingText,
      p = n.imageAltText,
      h = n.imageSrcDefault,
      b = n.imageSrcDefaultWebp,
      T = n.imageSrcMobile,
      y = n.imageSrcMobileWebp,
      C = n.introContent,
      v = n.moduleName,
      x = n.moduleVariation,
      j = n.reverseContent,
      E = n.sectionId,
      S = n.subHeadingText,
      D = n.themeType,
      w = t.useContext(a.ThemeContext).mediumUp(),
      U = t.useState(w),
      V = e._slicedToArray(U, 2),
      N = V[0],
      W = V[1],
      H = [{
        conditionFunc: function conditionFunc() {
          return h && !p;
        },
        message: "imageAltText is a required props on the InformationalModule (section ID '".concat(E, "') when imageSrcDefault is defined.")
      }, {
        conditionFunc: function conditionFunc() {
          return !h && (b || T || y);
        },
        message: "imageSrcDefault is undefined on the InformationalModule (section ID '".concat(E, "'). imageSrcDefault must also be passed in when other image props are defined.")
      }, {
        conditionFunc: function conditionFunc() {
          return !g && !S && !f;
        },
        message: "headingText and subHeadingText props are both missing for InformationalModule (section ID '".concat(E, "'). You must pass in a value for at least one or both of them.")
      }, {
        conditionFunc: function conditionFunc() {
          return h && c;
        },
        message: "Both the imageSrcDefault and columnContentB props detected on the InformationalModule (section ID '".concat(E, "'). Please pass in only imageSrcDefault or columnContentB.")
      }];
    return t.useEffect(function () {
      !function (e) {
        e.forEach(function (e) {
          e.conditionFunc && e.conditionFunc() && console.warn(e.message);
        });
      }(H);
    }, []), t.useEffect(function () {
      w === N && W(w);
    }, [w]), q["default"].createElement(o.SectionContainerComponent, {
      backgroundVariant: u,
      className: d,
      disableBottomPadding: m,
      id: E,
      moduleName: v,
      moduleVariation: x,
      themeType: D
    }, f && q["default"].createElement(i.AssistiveTextComponent, {
      component: "h2"
    }, f), (g || C) && q["default"].createElement(r.Row, {
      align: "center"
    }, q["default"].createElement(A, {
      medium: 10,
      large: 8
    }, q["default"].createElement(l.TypographyComponent, {
      id: "".concat(E, "-heading"),
      component: O(f, g),
      variant: "h2",
      align: "center",
      nextElement: C ? "typography" : "graphic",
      themeType: D,
      subHeadingText: S,
      imageSrcDefault: h
    }, g), C)), (s || c || h) && q["default"].createElement(B, {
      align: "center",
      reverseContent: j
    }, q["default"].createElement(L, {
      medium: h || c ? 6 : 10,
      large: h || c ? 6 : 8,
      reverseContent: j,
      imageSrcDefault: h,
      isTwoColumn: h || c
    }, S && q["default"].createElement(P, {
      id: "".concat(E, "-sub-heading"),
      component: F(f, g),
      variant: M(g, N),
      themeType: D
    }, S), h && !w && q["default"].createElement(I, null, T ? q["default"].createElement(q["default"].Fragment, null, k(T, y, p)) : q["default"].createElement(q["default"].Fragment, null, k(h, b, p))), s), h && w && q["default"].createElement(_, {
      medium: 6,
      reverseContent: j
    }, k(h, b, p)), c && !h && q["default"].createElement(L, {
      medium: 6,
      reverseContent: j,
      isTwoColumn: h || c
    }, c)));
  };
U.propTypes = {
  backgroundVariant: E["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  className: E["default"].string,
  columnContentA: E["default"].any,
  columnContentB: E["default"].any,
  disableBottomPadding: E["default"].bool,
  headingAssistiveText: E["default"].oneOfType([E["default"].string, E["default"].object]),
  headingText: E["default"].oneOfType([E["default"].string, E["default"].object]),
  imageAltText: E["default"].oneOfType([E["default"].string, E["default"].object]),
  imageSrcDefault: E["default"].oneOfType([E["default"].string, E["default"].object]),
  imageSrcDefaultWebp: E["default"].oneOfType([E["default"].string, E["default"].object]),
  imageSrcMobile: E["default"].oneOfType([E["default"].string, E["default"].object]),
  imageSrcMobileWebp: E["default"].oneOfType([E["default"].string, E["default"].object]),
  introContent: E["default"].any,
  moduleName: E["default"].string,
  moduleVariation: E["default"].string,
  reverseContent: E["default"].bool,
  sectionId: E["default"].string.isRequired,
  themeType: E["default"].oneOf(["lightTheme", "darkTheme"])
}, U.defaultProps = {
  backgroundVariant: "lightA",
  themeType: "lightTheme",
  reverseContent: !1,
  disableBottomPadding: !1,
  moduleName: "informational-module",
  moduleVariation: "A"
}, module.exports = U;